import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Layout from "@/components/Layout";
import MantenimientoTab from "@/components/quote/MantenimientoTab";
import ConsideracionesDefaults from "@/components/ConsideracionesDefaults";

export default function Maintenance() {
  const nav = useNavigate();
  return (
    <Layout>
      <button data-testid="maintenance-back" onClick={() => nav("/")}
        className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-4 transition-colors">
        <ArrowLeft className="h-4 w-4" /> Volver a cotizaciones
      </button>
      <h1 className="font-display text-3xl font-extrabold text-slate-900">Mantenimiento</h1>
      <p className="text-slate-500 mt-1 text-sm mb-6">
        Catálogo de características, tablas de referencia y consideraciones comerciales para nuevas cotizaciones. Los parámetros de importación y flete se ajustan dentro de cada cotización.
      </p>
      <div data-testid="maintenance-page" className="space-y-6"><MantenimientoTab globalOnly /><ConsideracionesDefaults /></div>
    </Layout>
  );
}
